import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Loader from '../shared/loader';

class PrivateRoute extends React.Component<
  { component; match; isLoggedIn; shouldPasswordBeSet; isPasswordSet; location: any; initial },
  { from: string }
> {
  static KEY = 'redirect';

  constructor(props) {
    super(props);
    this.renderComponent = this.renderComponent.bind(this);
    this.redirectToLogin = this.redirectToLogin.bind(this);
    this.redirectToSetPassword = this.redirectToSetPassword.bind(this);
  }

  redirectTo(url) {
    let originalLocation = JSON.parse(sessionStorage.getItem(PrivateRoute.KEY) || '""') || this.props.location;
    const { location: { state: { from = originalLocation } = {} } = {} } = this.props;
    sessionStorage.setItem(PrivateRoute.KEY, JSON.stringify(from));

    return (
      <Redirect
        to={{
          pathname: url,
          state: { from }
        }}
      />
    );
  }

  redirectToSetPassword() {
    return this.redirectTo('/set-password');
  }

  renderComponent(props) {
    const { component: Component } = this.props;
    return <Component {...props} />;
  }

  redirectToLogin() {
    return this.redirectTo('/login');
  }

  render() {
    const { initial, isLoggedIn, shouldPasswordBeSet, isPasswordSet, ...rest } = this.props;
    if (initial) {
      return <Loader />;
    }
    const { match: { path } } = rest;
    if (isLoggedIn) {
      if (shouldPasswordBeSet && !isPasswordSet && path !== '/set-password') {
        return this.redirectToSetPassword();
      }
      if (path !== '/set-password') {
        sessionStorage.removeItem(PrivateRoute.KEY);
      }
      return this.renderComponent(rest);
    }
    return this.redirectToLogin();
  }
}

const mapStateToProps = component => (state, props) => {
  return {
    isLoggedIn: state.isLoggedIn,
    shouldPasswordBeSet: state.shouldPasswordBeSet,
    isPasswordSet: state.isPasswordSet,
    initial: state.user && state.user.initial,
    component
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

const container: (any) => React.ComponentClass<any> = component =>
  connect(mapStateToProps(component), mapDispatchToProps)(PrivateRoute);

export default ({ component, ...rest }) => <Route {...rest} component={container(component)} />;



// WEBPACK FOOTER //
// ./src/my-app/private-route.tsx